import React from "react";
import Chose from "../../../../../../../assets/icon/svg/cards/chose";
import Link from "../../../../../../../assets/icon/svg/cards/link";
import Message from "../../../../../../../assets/icon/svg/cards/message";
import Phone from "../../../../../../../assets/icon/svg/cards/phone";
import { TYPE_POPOVER } from "../constants";
import { generateUUID, processChangeCard } from "../../../../../../../services/helpers/Helper";
import { BLOCK_DEFAULT } from "../../../constants/constants";
import { connect } from "react-redux";
import { openModal } from "../../../../../../../store/action/modalAction";
import ListBlocks from "./list-blocks";

const TextPopover = (props) => {
   const { onChange, faqId, index, handleChangeButton, openModal } = props;
   let { card, data, buttons } = props;

   const handleAddWebview = () => {
      const idBtn = generateUUID();
      if (handleChangeButton) {
         buttons[index].action = {
            type: TYPE_POPOVER.URL,
            value: "",
            temporary_block_id: idBtn
         };
         handleChangeButton(buttons);
      }
      if (onChange) {
         data.blocks = [...data.blocks, {
            type: TYPE_POPOVER.ICEBREAKER,
            title: "",
            temporary_block_id: idBtn,
            is_hidden: 1,
            is_first_block: 0
         }];
         onChange(data);
      }
   }

   const handleAddPhone = () => {
      const idBtn = generateUUID();
      if (handleChangeButton) {
         buttons[index].action = {
            type: TYPE_POPOVER.PHONE_NUMBER,
            value: "+84",
            temporary_block_id: idBtn
         };
         handleChangeButton(buttons);
      }
      if (onChange) {
         data.blocks = [...data.blocks, {
            type: TYPE_POPOVER.ICEBREAKER,
            title: "",
            temporary_block_id: idBtn,
            is_hidden: 1,
            is_first_block: 0
         }];
         onChange(data);
      }
   }

   const handleAddMessage = () => {
      const idBtn = generateUUID();
      if (handleChangeButton) {
         buttons[index].action = {
            type: TYPE_POPOVER.BLOCK,
            value: "",
            temporary_block_id: idBtn
         };
         handleChangeButton(buttons);
      }

      if (onChange) {
         data = processChangeCard(data, card, faqId);
         data.blocks = [...data.blocks, { ...BLOCK_DEFAULT, temporary_block_id: idBtn }];
         onChange(data);
      }
   }

   const handleChoseBlock = () => {
      const data = {
         children: <ListBlocks
            {...props}
         />
      }
      openModal(data);
   }

   return (
      <React.Fragment>
         <div className="width100 mb10 mt76">
            <label className="text-smaller">Hành động khi nhấn nút:</label>
            <ul>
               <div className="width100 mb5" onClick={handleAddMessage}>
                  <div className="p-t10">
                     <a className="btn btn-default button-action button-action-new-message block-display mb10">
                        <Message />
                        <span className="ml15-i text-button-action text-overflow-ellipsis">
                           Tạo tin nhắn mới
                        </span>
                     </a>
                  </div>
               </div>
               <div onClick={handleAddWebview}>
                  <a className="btn btn-default button-action block-display mb10 button-action-url ">
                     <Link />
                     <span className="ml15-i text-button-action text-overflow-ellipsis ">
                        Mở trang web
                     </span>
                  </a>
               </div>
               <div onClick={handleAddPhone}>
                  <a className="btn btn-default button-action block-display mb10 button-action-phone ">
                     <Phone />
                     <span className="ml15-i text-button-action text-overflow-ellipsis ">
                        Gọi điện thoại
                     </span>
                  </a>
               </div>
               {/* <a className="btn btn-default button-action block-display mb10 ps-relative button-action-condition">
                  <Condition />
                  <span className="ml15-i text-button-action text-overflow-ellipsis">
                     Điều kiện
                  </span>
               </a> */}
               {/* <a className="btn btn-default button-action block-display mb10 ps-relative button-action-start-another-flow">
                  <GoToContent />
                  <span className="ml15-i text-button-action text-overflow-ellipsis">
                     Đi đến nội dung
                  </span>
               </a> */}
               <div onClick={handleChoseBlock}>
                  <a className="btn btn-default button-action block-display mb10 button-action-select-exist">
                     <Chose />
                     <span className="ml15-i text-button-action text-overflow-ellipsis">
                        Chọn từ danh sách đã có
                     </span>
                  </a>
               </div>
            </ul>
         </div>
         {/* <div className="width100 mt30 mb5 card-button-additional-action-wrapper">
               <label className="text-smaller">
                  Hành động đi kèm:
               </label>
               <div className="input-select input-select-action"><a className="block-display">
                  <div className="btn btn-default width100"><span className="color-black">+ Thêm hành động</span></div>
               </a>
                  <div className="input-select-action-wrapper text-smaller ">
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Thêm tag
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Gỡ tag
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Thông báo cho Quản trị viên
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Đăng ký theo dõi Bot
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Hủy đăng ký theo dõi Bot
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Thiết lập Custom field
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Hủy thiết lập Custom field
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Đăng ký theo dõi kịch bản
                        </span></div>
                     </div>
                     <div className="input-select-action-item pointer">
                        <div><span className="flex-display ws-nw">
                           <div className="svg-next-icon visibility-hidden mr5 next-icon-checkmark">
                           </div>Hủy đăng ký theo dõi kịch bản
                        </span></div>
                     </div>
                  </div>
               </div>
            </div> */}
      </React.Fragment>
   )
}

const mapStateToProps = () => {
   return {

   }
}
export default connect(mapStateToProps, {
   openModal
})(TextPopover);